<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--8-col mdl-cell--6-col-tablet mdl-cell--2-col-phone">
      <span block>¡Bienvenido, <strong>{{ $user.data.givenName }}</strong>!</span>
      <small>{{ $user.data.role.toUpperCase() }}</small>
      <!-- <span>0 Auditorias - Sin actividad reciente</span> -->
    </div>

    <div class="mdl-cell mdl-cell--4-col mdl-cell--2-col-tablet mdl-cell--2-col-phone">
      <span class="mdl-typography--text-right" block>{{ formatDate() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    formatDate () {
      const date = new Date(),
        monthNames = [
          'Enero', 'Febrero', 'Marzo',
          'Abril', 'Mayo', 'Junio', 'Julio',
          'Agosto', 'Septiembre', 'Octubre',
          'Noviembre', 'Diciembre'
        ],
        day = date.getDate(),
        monthIndex = date.getMonth(),
        year = date.getFullYear()

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
  }
}
</script>

<style lang="css" scoped>
  .mdl-grid {
    background-color: #fff;
  }

  [block] {
    display: block;
  }
</style>


// WEBPACK FOOTER //
// Welcome.vue?6d2c6dd5